import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion3 from '../../../../ui/images/questions/ela/grade-k4/question-3.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k4/question-5.png'
import imgQuestion8 from '../../../../ui/images/questions/ela/grade-k4/question-8.png'

export const questionsTest: AssessmentQuestion[] = [
  {
    name: 'grade_k4_1',
    title: 'Which word has the same vowel sound as "plane"?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k4_1_a',
        text: 'plan',
      },
      {
        name: 'grade_k4_1_b',
        text: 'planned',
      },
      {
        name: 'grade_k4_1_c',
        text: 'rain',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_2',
    title: 'Which of these statements made by a speaker is a verifiable fact?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k4_2_a',
        text: '"Our school has the most talented students in the city."',
      },
      {
        name: 'grade_k4_2_b',
        text: '"The student council meeting starts at 3:00 PM in Room 12."',
        correct: true,
      },
      {
        name: 'grade_k4_2_c',
        text: '"Everyone thinks that the new cafeteria food is delicious."',
      },
    ],
  },
  {
    name: 'grade_k4_3',
    title: 'What does the expression "Piece of cake" mean?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion3,
    answers: [
      {
        name: 'grade_k4_3_a',
        text: 'A slice of cake.',
      },
      {
        name: 'grade_k4_3_b',
        text: 'Something that is very easy.',
        correct: true,
      },
      {
        name: 'grade_k4_3_c',
        text: 'A small piece of food.',
      },
    ],
  },
  {
    name: 'grade_k4_4',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Even though the puzzle had a thousand pieces and looked impossible, Maya stayed at the table for three hours until the very last piece was in its place."',
    sentence: 'Which word best describes Maya\'s character?',
    answers: [
      {
        name: 'grade_k4_4_a',
        text: 'Impatient',
      },
      {
        name: 'grade_k4_4_b',
        text: 'Persistent',
        correct: true,
      },
      {
        name: 'grade_k4_4_c',
        text: 'Careless',
      },
    ],
  },
  {
    name: 'grade_k4_5',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Bees are the park\'s most important workers. As they fly from flower to flower, they carry pollen that helps plants create new seeds. Without these busy insects, the park would lose its colorful flowers and green plants."',
    sentence: 'What is the main idea of this text?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k4_5_a',
        text: 'Bees like to fly in big parks.',
      },
      {
        name: 'grade_k4_5_b',
        text: 'Bees play a vital role in helping the park\'s nature grow.',
        correct: true,
      },
      {
        name: 'grade_k4_5_c',
        text: 'Flowers are more important than insects.',
      },
    ],
  },
  {
    name: 'grade_k4_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Liam and his sister Emma went to the beach last weekend. They built a big sandcastle together and collected seashells along the shore. Afterward, they enjoyed a picnic under a shady tree.',
    sentence: 'Where did Liam and Emma have their picnic?',
    answers: [
      {
        name: 'grade_k4_6_a',
        text: 'On the sandcastle.',
      },
      {
        name: 'grade_k4_6_b',
        text: 'On the beach chairs.',
      },
      {
        name: 'grade_k4_6_c',
        text: 'In a shade.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_7',
    title: 'Which transition word best shows a cause-and-effect relationship?',
    topic: AssessmentTopics.Writing,
    detail: 'I studied for my spelling test all weekend. ______, I earned a perfect score on Monday morning.',
    answers: [
      {
        name: 'grade_k4_7_a',
        text: 'However',
      },
      {
        name: 'grade_k4_7_b',
        text: 'As a result',
        correct: true,
      },
      {
        name: 'grade_k4_7_c',
        text: 'For example',
      },
    ],
  },
  {
    name: 'grade_k4_8',
    title: 'Choose the best word to complete the sentence:',
    topic: AssessmentTopics.Writing,
    detail: 'I have _____ homework to do tonight.',
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k4_8_a',
        text: 'many',
      },
      {
        name: 'grade_k4_8_b',
        text: 'much',
      },
      {
        name: 'grade_k4_8_c',
        text: 'a lot of',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_9',
    title: 'Which sentence uses punctuation correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k4_9_a',
        text: 'Wow I can\'t believe it!',
      },
      {
        name: 'grade_k4_9_b',
        text: 'Wow! I can\'t believe it?',
      },
      {
        name: 'grade_k4_9_c',
        text: 'Wow! I can\'t believe it!',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_10',
    title: 'Which word is a pronoun in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'Maria gave her book to Tom.',
    answers: [
      {
        name: 'grade_k4_10_a',
        text: 'Maria',
      },
      {
        name: 'grade_k4_10_b',
        text: 'her',
        correct: true,
      },
      {
        name: 'grade_k4_10_c',
        text: 'book',
      },
    ],
  },
  {
    name: 'grade_k4_11',
    title: 'Choose the sentence with correct subject-verb agreement:',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k4_11_a',
        text: 'The dogs runs fast.',
      },
      {
        name: 'grade_k4_11_b',
        text: 'The dog run fast.',
      },
      {
        name: 'grade_k4_11_c',
        text: 'The dogs run fast.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_12',
    title: 'Which sentence is written correctly with the conjunction at the beginning?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k4_12_a',
        text: 'Although it was very late, the store was still open.',
        correct: true,
      },
      {
        name: 'grade_k4_12_b',
        text: 'Although, it was very late the store was still open.',
      },
      {
        name: 'grade_k4_12_c',
        text: 'Although it was very late the store, was still open.',
      },
    ],
  },
]
